"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Speciality = void 0;
var Speciality;
(function (Speciality) {
    Speciality["Medicine"] = "medicine";
    Speciality["Nursing"] = "nursing";
    Speciality["Physiotherapy"] = "physiotherapy";
    Speciality["Dentistry"] = "dentistry";
    Speciality["SportsMedicine"] = "sportsMedicine";
    Speciality["Optometry"] = "optometry";
    Speciality["AlternativeMedicine"] = "alternativeMedicine";
    Speciality["Anatomy"] = "anatomy";
    Speciality["GeneralMedicine"] = "generalMedicine";
    Speciality["Physiology"] = "physiology";
    Speciality["DrawingAnatomy"] = "drawingAnatomy";
    Speciality["Fitness"] = "fitness";
    Speciality["SelfEducation"] = "selfEducation";
    Speciality["GeneralPractitioner"] = "generalPractitioner";
    Speciality["Surgery"] = "surgery";
    Speciality["InternalMedicine"] = "internalMedicine";
    Speciality["EmergencyMedicine"] = "emergencyMedicine";
    Speciality["Radiology"] = "radiology";
    Speciality["Osteopathy"] = "osteopathy";
    Speciality["Anesthesiology"] = "anesthesiology";
    Speciality["Orthopedics"] = "orthopedics";
    Speciality["OccupationalTherapy"] = "occupationalTherapy";
    Speciality["Chiropractor"] = "chiropractor";
    Speciality["Homeopathy"] = "homeopathy";
    Speciality["Acupuncture"] = "acupuncture";
    Speciality["MassageTherapy"] = "massageTherapy";
    Speciality["Other"] = "other";
})(Speciality || (exports.Speciality = Speciality = {}));
